module.exports = __webpack_public_path__ + "img/microphone_off.846e977d.svg";